import { Modal } from './Modal'
import { btnPrimary, btnSecondary, btnDanger } from './styles'
import type { CSSProperties } from 'react'

interface ConfirmDialogProps {
  readonly isOpen: boolean
  readonly onClose: () => void
  readonly onConfirm: () => void
  readonly title: string
  readonly message: string
  readonly confirmLabel?: string
  readonly cancelLabel?: string
  readonly variant?: 'danger' | 'primary'
  readonly loading?: boolean
}

const messageStyle: CSSProperties = {
  fontSize: '0.9375rem',
  lineHeight: 1.6,
  marginBottom: '1.25rem',
}

const actions: CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '0.75rem',
}

export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  loading = false,
}: ConfirmDialogProps) {
  const confirmStyle = variant === 'danger' ? btnDanger : btnPrimary

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} width="420px">
      <p style={messageStyle}>{message}</p>
      <div style={actions}>
        <button style={btnSecondary} onClick={onClose} disabled={loading}>
          {cancelLabel}
        </button>
        <button
          style={{ ...confirmStyle, opacity: loading ? 0.6 : 1 }}
          onClick={onConfirm}
          disabled={loading}
          data-testid="confirm-button"
        >
          {loading ? 'Processing...' : confirmLabel}
        </button>
      </div>
    </Modal>
  )
}
